var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._l((_vm.polygons),function(item,index){return _c('l-polygon',{key:index,attrs:{"lat-lngs":item,"weight":2,"color":_vm.PURPLE_COLOR}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }